<template>
  <li>
    <div v-if="divided" class="dropdown__divider"></div>
    <a :class="classes" @click.stop="$_onDropdownItemClick">
      <slot></slot>
    </a>
  </li>
</template>
<script>
const prefixCls = 'dropdown__item'
export default {
  name: 'TDropdownItem',
  props: {
    name: {
      type: [String, Number]
    },
    value: {
      type: [String, Number, Object, Array]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    divided: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSelected: this.selected
    }
  },
  computed: {
    classes() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}--disabled`]: this.disabled,
          [`${prefixCls}--checked`]: this.isSelected
        }
      ]
    }
  },
  watch: {
    selected (val) {
      this.isSelected = val
    }
  },
  mounted() {
    this.$on('dropdown-menu-select-item', value => {
      if (value !== undefined && this.name === value) {
        this.isSelected = true
      } else {
        this.isSelected = false
      }
    })
    this.$on('on-selected-change', function(key) {
      this.isSelected = key === this.name
    })
  },
  methods: {
    $_onDropdownItemClick(event) {
      let $parent = null
      if (this.$parent && this.$parent.$parent && this.$parent.$parent.$parent) {
        $parent = this.$parent.$parent.$parent
      }
      const hasChildren =
        this.$parent && this.$parent.$options.name === 'TDropdown'
      if (this.disabled) {
        if ($parent) {
          this.$nextTick(() => {
            $parent.currentVisible = true
          })
        }
      } else if (hasChildren) {
        this.$parent && this.$parent.$emit('on-haschild-click')
      } else {
        if ($parent && $parent.$options.name === 'TDropdown') {
          $parent.$emit('on-hover-click')
        }
      }
      if ($parent) {
        $parent.$emit('on-click', this.name, this.value)
      }
      if (this.disabled === false) {
        this.$parent && this.$parent.$emit('dropdown-item-click', {
          name: this.name,
          value: this.value
        })
      }
      this.$emit('on-click', event)
    }
  }
}

</script>



// WEBPACK FOOTER //
// dropdown-item.vue?f402d76e